import confirmation from "../../../../../../image/goods.image/humates/confirmation1.jpg";

export default function description() {
    return (
        <div className="card__description-basic">
            <div className="card__description">
                <p className="card__description-text">
                    Відновіть ґрунт — збільште врожай без зайвої хімії
                </p>
                <p className="card__description-text">
                    Якщо рослини ростуть повільно, урожай з кожним роком слабшає, а ґрунт «виснажується» — причина в його структурі.
                </p>
                <p className="card__description-text">
                    Біочар IDEALE™ працює там, де звичайні добрива безсилі — він відновлює ґрунт зсередини.
                </p>
                <p className="card__description-title">
                    Ефект, який ви помітите:
                    <ol className="card__description-list">
                        <li className="card__description-numbering">
                            швидке укорінення розсади
                        </li>
                        <li className="card__description-numbering">
                            активний ріст овочів, ягід і плодових дерев
                        </li>
                        <li className="card__description-numbering">
                            збільшення врожайності
                        </li>
                        <li className="card__description-numbering">
                            покращення смаку та якості плодів
                        </li>
                        <li className="card__description-numbering">
                            менше хвороб і стресу у рослин
                        </li>
                    </ol>
                </p>
                <p className="card__description-title">
                    Чому це працює:
                    <p className="card__description-text">
                        Біочар — це природний пористий матеріал, який:
                    </p>
                    <ol className="card__description-list">
                        <li className="card__description-numbering">
                            утримує вологу та поживні речовини
                        </li>
                        <li className="card__description-numbering">
                            покращує структуру ґрунту
                        </li>
                        <li className="card__description-numbering">
                            активує корисну мікрофлору
                        </li>
                        <li className="card__description-numbering">
                            зменшує вимивання добрив
                        </li>
                    </ol>
                    <p className="card__description-text">
                        Простими словами: ви поливаєте і підживлюєте менше, а результат — кращий.
                    </p>
                </p>
                <p className="card__description-title">
                    Ідеально підходить для:
                    <ol className="card__description-list">
                        <li className="card__description-numbering">
                            овочевих культур (помідори, огірки, перець)
                        </li>
                        <li className="card__description-numbering">
                            ягідних кущів (малина, смородина)
                        </li>
                        <li className="card__description-numbering">
                            плодових дерев
                        </li>
                        <li className="card__description-numbering">
                            теплиць та відкритого ґрунту
                        </li>
                    </ol>
                </p>
                <p className="card__description-title">
                    Перевага, яка економить гроші:
                    <p className="card__description-text">
                        Біочар IDEALE™ не просто підживлює — він створює довготривалий запас родючості, тому потреба в добривах значно зменшується.
                    </p>
                </p>
                <p className="card__description-title">
                    Перевага, яка економить гроші:
                    <p className="card__description-text">
                        Зручна упаковка 2 л — оптимально для дачі, городу або саду.
                    </p>
                </p>
                <p className="card__description-title">
                    Результат:
                    <p className="card__description-text">
                        Сильні рослини, стабільний урожай і здоровий ґрунт без виснаження.
                    </p>
                </p>
                <p className="card__description-title">
                    Ґрунт не дає врожаю? Ви годуєте рослини — а треба “нагодувати” землю
                </p>
                <p className="card__description-text">
                    Реальність проста: якщо ґрунт виснажений — жодні добрива не дадуть стабільного результату.
                </p>
                <p className="card__description-text">
                    Саме тому працює Біочар IDEALE™
                </p>
                <p className="card__description-text">
                    Це не підживлення.
                </p>
                <p className="card__description-title">
                    Це основа родючості, яка змінює все:
                    <ol className="card__description-list">
                        <li className="card__description-numbering">
                            запускає природні процеси в ґрунті
                        </li>
                        <li className="card__description-numbering">
                            утримує вологу та поживні речовини
                        </li>
                        <li className="card__description-numbering">
                            допомагає рослинам брати максимум із кожного поливу
                        </li>
                        <li className="card__description-numbering">
                            відновлює землю на роки вперед
                        </li>
                    </ol>
                </p>
                <p className="card__description-title">
                    Що зміниться після використання:
                    <ol className="card__description-list">
                        <li className="card__description-numbering">
                            рослини стають сильнішими вже на старті
                        </li>
                        <li className="card__description-numbering">
                            урожай росте навіть без збільшення добрив
                        </li>
                        <li className="card__description-numbering">
                            ґрунт перестає “виснажуватись” щосезону
                        </li>
                    </ol>
                </p>
                <p className="card__description-title">
                    Чому це вигідно: Ви перестаєте “годувати повітря” добривами, а починаєте працювати з причиною — якістю ґрунту.
                </p>
                <p className="card__description-title">
                    ⚠️ Важливо:
                </p>
                <p className="card__description-text">
                    але ігнорують основу.
                </p>
                <p className="card__description-text">
                    Ті, хто додає біочар — отримують кращий результат при менших витратах
                </p>
                <p className="card__description-title">
                    Біочар IDEALE™ — 2 л
                </p>
                <p className="card__description-text">
                    Ідеально для городу, кущів і дерев
                </p>
                <p className="card__description-title">
                    Хочеш нормальний урожай, а не “як пощастить”?
                </p>
                <p className="card__description-text">
                    Спробуй один раз — і різниця буде очевидна.
                </p>
                <p className="card__description-title">
                    Норма внесення Біочар IDEALE™
                </p>
                <p className="card__description-text">
                    🔹 Для розсади та кімнатних рослин: 10-15% на 1 літр ґрунту (ретельно перемішати)
                </p>
                <p className="card__description-text">
                    🔹 Для відкритого ґрунту (город): 0,5–1 л на 1 м² (рівномірно розсипати та перекопати на глибину 10–15 см)
                </p>
                <p className="card__description-text">
                    🔹 Для кущів: 0,5–1 л під кущ (внести в прикореневу зону та змішати з ґрунтом)
                </p>
                <p className="card__description-text">
                    🔹  1–2 л на одне дерево (обкопати по колу крони, з легким загортанням у ґрунт)
                </p>
                <p className="card__description-text">
                    🔹  Для теплиць: 1 л на 1 м² перед посадкою або додавати локально в лунки
                </p>
                <div className="biochar_confirmation">
                    <img src={confirmation} alt="Підтвердження" />
                </div>
            </div>
            <div className="card__description-preference">
                <div className="aside__title">Агрохімічні характеристики</div>
                <div className="aside__content">
                    <div className="aside-char">
                        <div className="aside-char__head">Потенціал врожайності</div>
                        <div className="aside-char__char">
                            <div className="aside-char__items aside-char__items--8">
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                            <div className="aside-char__count">8</div>
                        </div>
                    </div>
                    <div className="aside-char">
                        <div className="aside-char__head">Стабільність урожаю</div>
                        <div className="aside-char__char">
                            <div className="aside-char__items aside-char__items--7">
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                            <div className="aside-char__count">7</div>
                        </div>
                    </div>
                    <div className="aside-char">
                        <div className="aside-char__head">Енергія початкового росту</div>
                        <div className="aside-char__char">
                            <div className="aside-char__items aside-char__items--8">
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                            <div className="aside-char__count">8</div>
                        </div>
                    </div>
                    <div className="aside-char">
                        <div className="aside-char__head">Ефективність</div>
                        <div className="aside-char__char">
                            <div className="aside-char__items aside-char__items--9">
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                            <div className="aside-char__count">9</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
